var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailSecTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 35,
    viewBox: "0 0 41 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.23333L7.59496 13.9209C7.96436 14.2305 8.43 14.4 8.91088 14.4H32.089C32.57 14.4 33.0356 14.2305 33.405 13.9209L39 9.23333M9.19444 21.6333H9.215M31.8056 21.6333H31.8261M12.608 2H28.3921C29.8674 2 31.2296 2.79478 31.9614 4.08262L37.9167 14.5606C38.6265 15.8097 39 17.2233 39 18.6621V30.9333C39 32.0748 38.0797 33 36.9444 33H34.8889C33.7536 33 32.8333 32.0748 32.8333 30.9333V28.8667H8.16667V30.9333C8.16667 32.0748 7.24635 33 6.11111 33H4.05556C2.92031 33 2 32.0748 2 30.9333V18.6621C2 17.2233 2.37341 15.8097 3.08334 14.5606L9.03855 4.08262C9.77049 2.79478 11.1327 2 12.608 2ZM10.2222 21.6333C10.2222 22.2039 9.76207 22.6667 9.19444 22.6667C8.62682 22.6667 8.16667 22.2039 8.16667 21.6333C8.16667 21.0627 8.62682 20.6 9.19444 20.6C9.76207 20.6 10.2222 21.0627 10.2222 21.6333ZM32.8333 21.6333C32.8333 22.2039 32.3731 22.6667 31.8056 22.6667C31.238 22.6667 30.7778 22.2039 30.7778 21.6333C30.7778 21.0627 31.238 20.6 31.8056 20.6C32.3731 20.6 32.8333 21.0627 32.8333 21.6333Z",
    stroke: "#48C2C5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailSecTransfer);
export default __webpack_public_path__ + "static/media/detail-sec-transfer.7704efbcd609ba05fc2e70e31b32e2f7.svg";
export { ForwardRef as ReactComponent };